module.exports = __webpack_public_path__ + "media/images/advisor/img_5_1-c8a22a4efb86598824759adbb1a49f59.png";